"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const bottomTabNavigationStyles_1 = __importDefault(require("./bottomTabNavigationStyles"));
const screenConstants_1 = require("../../constants/screenConstants");
const useAppNavigation_1 = __importDefault(require("../../hooks/useAppNavigation"));
const pressableElement_1 = __importDefault(require("../pressables/pressableElement"));
const styles_1 = __importDefault(require("../../styles/styles"));
const text_1 = __importStar(require("../text/text"));
const icon_1 = __importStar(require("../icon/icon"));
const colors_1 = __importDefault(require("../../styles/colors"));
const NavItem = ({ onPress, itemName, currentTab, displayName, icon }) => {
    return (react_1.default.createElement(react_native_1.View, { style: [
            styles_1.default.centerChildHorizontalVertical,
            styles_1.default.minimumMarginBetweenElementsVertically,
            { marginHorizontal: 20 },
        ] },
        react_1.default.createElement(pressableElement_1.default, { onPress: onPress, eventName: "navigate_dashboard" },
            react_1.default.createElement(react_native_1.View, { style: {
                    justifyContent: 'center',
                    alignItems: 'center',
                } },
                react_1.default.createElement(icon_1.default, { name: icon, fill: currentTab === itemName ? colors_1.default.COLOR_PRIMARY : colors_1.default.COLOR_GRAY_DARK })),
            react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, style: currentTab === itemName ? bottomTabNavigationStyles_1.default.activeTabText : bottomTabNavigationStyles_1.default.inactiveTabText }, displayName))));
};
const NavTabs = ({ currentTab }) => {
    const navigation = (0, useAppNavigation_1.default)();
    return (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, styles_1.default.justifySpaceBetween, { borderRadius: 12 }] },
        react_1.default.createElement(NavItem, { onPress: () => navigation.reset({ index: 0, routes: [{ name: screenConstants_1.HOME_SCREEN }] }), itemName: screenConstants_1.HOME_SCREEN, currentTab: currentTab, displayName: "Home", icon: icon_1.HOME_ICON }),
        react_1.default.createElement(NavItem, { onPress: () => navigation.reset({ index: 0, routes: [{ name: screenConstants_1.HOME_SCREEN }, { name: screenConstants_1.LOAN_HOME_SCREEN }] }), itemName: screenConstants_1.LOAN_HOME_SCREEN, currentTab: currentTab, displayName: "Loans", icon: icon_1.LOAN_ICON }),
        react_1.default.createElement(NavItem, { onPress: () => navigation.reset({ index: 0, routes: [{ name: screenConstants_1.HOME_SCREEN }, { name: screenConstants_1.PROFILE_SCREEN }] }), itemName: screenConstants_1.PROFILE_SCREEN, currentTab: currentTab, displayName: "Profile", icon: icon_1.PROFILE_ICON })));
};
exports.default = NavTabs;
